import "./About.css";
import aboutImage from "../img/about-company.png";

function About() {

    return (

        <div className="about-container">

            <div className="about-image">

                <img
                    src={aboutImage}
                    alt="3 Point Signs"
                />

            </div>

            <div className="about-content">

                <span className="section-tag">
                    ABOUT US
                </span>

                <h2>
                    Building Quality Signs That Make Businesses Stand Out
                </h2>

                <p>

                    With over 10 years of experience in the signage industry, 3 Point Signs specializes in designing,
                    manufacturing and installing custom signage solutions for businesses across Canada.

                </p>

                <p>

                    From storefront signs and channel letters to large
                    commercial projects, our experienced team delivers
                    reliable craftsmanship, premium materials and professional
                    installation from start to finish.

                </p>

                <button className="contact-button">

                <a
                    href={`mailto:info@3pointsigns.com?subject=Request%20for%20a%20Quote&body=Hello%203%20Point%20Signs,%0D%0A%0D%0AI%20would%20like%20to%20request%20a%20quote%20for%20a%20new%20signage%20project.%0D%0A%0D%0AThank%20you!`}

                    style={{ color: "white", textDecoration: "none" }}
                >

                    Request a Quote

                </a>
            </button>

            </div>

        </div>

    );

}

export default About;